
























































































































import {
  Vue, Prop, Component, Emit, Watch,
} from 'vue-property-decorator';
import DateFormat from '@/shared/utils/date-format';
import TextFieldAreaReadonlyInput from '@/shared/text-field/text-field-area-readonly-input.component.vue';
import TextFieldAreaBasicInput from '@/shared/text-field/text-field-area-basic-input.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import DatePickerMonthYear from '@/shared/date-picker/date-picker-month-year.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import JustifyPersist from '@/domain/justify/domain/justify-persist.entity';
import { JustifyType } from '../../domain/justify/domain/justify-type.enum';
import JustifyService from '../../domain/justify/service/justify.service';
import Justify from '../../domain/justify/domain/justify.entity';
import Rules from '../rules/rules';

@Component({
  components: {
    TextFieldAreaReadonlyInput,
    TextFieldAreaBasicInput,
    MainButton,
    LabelSlot,
    DatePickerMonthYear,
  },
})
export default class JustifyModal extends Vue {
  @Prop({
    required: true,
  })
  private showModal!: boolean;

  @Prop({
    required: true,
  })
  private businessUnitId!: string;

  @Prop({
    required: false,
    default: () => DateFormat.newfullDateAndTime(),
  })
  private date!: string;

  @Prop({
    required: true,
  })
  private type!: JustifyType;

  @Prop({
    required: false,
    default: false,
  })
  private disableCompetence!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })

  private showFileInput!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  private isContractGroup!: boolean;

  private file: any = null;

  private justifications: Justify[] = [];

  private rules: Rules = new Rules();

  private ref: any = this.$refs;

  private valid: boolean = false;

  private persistJustify: JustifyPersist = JustifyPersist.of({});

  private get modalLabelMassage() {
    if (this.type === JustifyType.CONTRACT_EXPIRATION_REVERSAL) {
      return 'Data da reversão';
    }
    return this.disableCompetence ? 'Data/Hora de Ativação' : 'Data/Hora de Inativação';
  }

  private get modalState() {
    return this.showModal;
  }

  private get showRevertAllFromContractGroupOption(): boolean {
    return this.type === JustifyType.CONTRACT_EXPIRATION_REVERSAL && this.isContractGroup;
  }

  private set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  saveJustify() {
    if (this.ref.form.validate()) {
      this.$emit('justify', {
        justify: this.persistJustify,
        file: this.file,
      });
    }
  }

  @Watch('showModal')
  getJustifications() {
    if (this.showModal) {
      JustifyService.getJustificationsByBusinessUnitAndType(
        this.businessUnitId,
        this.type,
      )
        .then((response: Justify[]) => this.justifications = response)
        .catch((err: any) => VbSnackbarService.handleHttpError(err));
    }
  }

  updateCompetences(event) {
    this.persistJustify.competenceStart = event
    this.persistJustify.competenceEnd = event
  }
}
